import { memo, useContext, useMemo } from 'react';
import { round } from 'mathjs';
import styles from './SliderDisplay.module.css';
import { AllInputDataContext } from '../../../config';

type Props = {
  techIndexNumber: number;
  technologyCost: number;
};

const SliderDisplay = memo(
  ({ techIndexNumber, technologyCost }: Props) => {
    const { technologyData, optionsData } = useContext(AllInputDataContext);
    const isGenerating = technologyCost > 0;

    const pettyTechnologyCost = useMemo(() => {
      let cost: number | string = technologyCost;

      if (technologyCost >= 1000) {
        cost = round(technologyCost / 1000, 2) + 'B';
      } else if (technologyCost === 0) {
      } else {
        cost = round(technologyCost, 2) + 'M';
      }
      return optionsData.currency + cost;
    }, [optionsData.currency, technologyCost]);

    const techTitleLowercase = technologyData[techIndexNumber].name
      .toLowerCase()
      .replace(/\s/g, '');

    return (
      <div
        className={styles.capacityDisplay}
        style={
          isGenerating
            ? {
                borderColor: technologyData[techIndexNumber].color,
              }
            : {}
        }
      >
        <div className={styles.costTooltip}>
          <span className={styles.costTooltiptext}>
            Capex + Running + Fixed Cost
          </span>
          <span id={techTitleLowercase + 'Cost'}>{pettyTechnologyCost}</span>
        </div>
      </div>
    );
  }
);

export default SliderDisplay;
